<template>

    <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

    <!-- search layer -->
    <!-- <div class="grey lighten-4">
        <div class="container section"></div>
    </div> -->

    <!-- breadcrumbs -->
    <nav class="sba-collection-breadcrumb care-billing-view-breadcrumb z-depth-0">
      <div class="container nav-wrapper">
        <div class="sba-collection-breadcrumb-row">
          <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
            <i class="material-icons">home</i>
            <span>Dashboard</span>
          </router-link>
          <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
          <router-link to="/care/billing" class="breadcrumb sba-collection-crumb teal-text">
            <span>Provider Billing</span>
          </router-link>
          <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
          <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
            <span>Review</span>
          </span>
          <span class="sba-collection-context">Billing Batch Review</span>
        </div>
      </div>
    </nav>


    <!-- main -->
    <div id="top"></div>

    <div class="sba-collection-page-surface is-workbench care-billing-view-surface">
        <div class="container claim-view-container care-billing-view-container">

        <LoadingDiv v-if="!isReady" />

        <div class="claim-review-workbench sba-slide-in" v-else>

            <div v-if="loadError || error" class="card-panel red lighten-5" role="alert">
                <p>{{ loadError || error }}</p>
                <button v-if="loadError" type="button" class="btn teal" :disabled="isLoading" @click="loadCluster">
                    <i class="material-icons left">refresh</i>Retry
                </button>
            </div>

            <!-- Success -->
            <SubmitSummary :cluster="success" @cancel="handleCancel" v-if="success" />

            <!-- Main Displays  -->
            <div id="mid-top"></div>
            <template v-if="cluster && !loadError">
                <section class="claim-secondary-header">
                    <section class="claim-super-card">
                        <button type="button" class="secondary-page-back" title="Back to Billing Home" @click.prevent="handleCancel">
                            <i class="material-icons">keyboard_return</i>
                        </button>
                        <div class="claim-super-copy">
                            <button type="button" class="secondary-parent-link" @click.prevent="handleCancel">Billing Home</button>
                            <small>Back to Billing List</small>
                        </div>
                    </section>

                    <section class="claim-dossier-card">
                        <div class="claim-dossier-title">
                            <label class="active teal-text">Billing Review</label>
                            <h5>{{ clusterPeriod }}</h5>
                            <p>Review this billing batch and submit final claims when ready.</p>
                        </div>

                        <div class="claim-dossier-context">
                            <span class="context-pill">{{ String(cluster.scheme?.name ?? 'Scheme not recorded').toUpperCase() }}</span>
                            <span class="context-pill">{{ clusterPeriod }}</span>
                            <span class="context-pill" :class="clusterStatusClass">{{ clusterStatusLabel }}</span>
                            <span class="context-pill is-payment">{{ clusterPaymentStatus }}</span>
                        </div>
                    </section>

                    <section class="claim-dossier-metrics">
                        <div class="metric-cell">
                            <span>Sent Total</span>
                            <strong class="metric-relaxed-value">&#8358;{{ billingSentTotal }}</strong>
                        </div>
                        <div class="metric-cell">
                            <span>Encounters</span>
                            <strong class="metric-relaxed-value">{{ encounters.length }} {{ encounters.length === 1 ? "visit" : "visits" }}</strong>
                        </div>
                        <div class="metric-cell">
                            <span>Stage</span>
                            <strong class="metric-relaxed-value">{{ clusterStatusLabel }}</strong>
                        </div>
                        <div class="metric-cell metric-action-cell">
                            <button type="button" class="download-action" :class="{ 'is-disabled': !canDownloadPaymentAdvice, 'is-submitted-download': cluster.status === 'p' }"
                                :disabled="!canDownloadPaymentAdvice" @click.prevent="handleDownload()">
                                <i class="material-icons">download</i>
                                <span>Payment Advice</span>
                            </button>
                        </div>
                    </section>

                    <section class="claim-mode-strip">
                        <button
                            type="button"
                            class="claim-mode-close"
                            title="Back to Billing Home"
                            aria-label="Back to Billing Home"
                            @click.prevent="handleCancel"
                        >
                            <i class="material-icons">close</i>
                        </button>
                        <div class="claim-mode-actions">
                            <button
                                v-for="tab in tabsState"
                                :key="tab.id"
                                type="button"
                                class="claim-mode-option"
                                :class="{ 'is-active': tab.id === currState?.id, 'is-disabled': isReviewTabDisabled(tab) }"
                                :disabled="isReviewTabDisabled(tab)"
                                @click="handleActiveState(tab)"
                            >
                                {{ tab.title }}
                                <span v-if="tab.title.toLowerCase().includes('summary')">({{ encounters.length ? encounters.length : 0 }})</span>
                            </button>
                        </div>
                    </section>
                </section>

                <section class="claim-secondary-body-frame">
                    <div class="progress" v-if="isLoading">
                        <div class="indeterminate"></div>
                    </div>

                    <div id="displays"></div>
                    <EnrolleeBill :cluster="cluster" :encounter="encounter" @back="handleEncounterBack"
                        @next="handleNext" @draft="handleDraft" @draft-clear="handleDraftClear"
                        @updated="handleEncounterUpdated" @removed="handleEncounterRemoved" v-if="next" />

                    <div v-else>
                        <SummaryBill :cluster="cluster" :encounters="encountersWithDraft" :isSubmitting="isSubmitting"
                            :isManual="true" @reload="handleReload" @cancel="handleCancel" />

                     <div class="care-submit-row" v-if="cluster.status === 'q'">
                            <button class="waves-effect waves-light btn-large care-add-enrollee-button"
                                v-if="canAddManualEncounter"
                                :class="{ disabled: isSubmitting }"
                                @click.prevent="handleAddEnrollee">
                                <i class="medium material-icons left">person_add</i>Add Enrollee
                            </button>

                            <button class="waves-effect waves-light btn-large btn modal-trigger care-submit-button"
                                :class="{
                                    disabled: isSubmitting || encountersWithDraft.find(x => x.status === 'q') || !encounters.length || lock,
                                }" data-target="confirmSubmit">
                                <i class="medium material-icons left">check_circle</i>{{ isSubmitting ? "Submit" :
                                    "Final Claims Submit"
                                }}
                            </button>
                            <!-- Confirmation -->
                            <Teleport to="body">
                                <Modal id="confirmSubmit" class="modal care-billing-confirm-modal" :title="alertTitle" :message="alertMessage"
                                    @confirm="handleConfirm" v-if="cluster" />
                            </Teleport>

                     </div>

                    </div>
                </section>
            </template>

        </div>

        </div>
    </div>


</template>


<script>
import { ref, onMounted, onUpdated, computed, watchEffect, watch, nextTick } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { ageSex, capWordsFx, } from "@/composables/fxLibrary/coreFx";
import getItemsOfItemsOfItems from "@/composables/getItemsOfItemsOfItems";
import getItems from "@/composables/getItems";
import putItem from "@/composables/putItem";
import { getCachedServerDate } from "@/composables/requestOptimization";
import { getCache, addCache, removeCache } from "@/composables/cache/cache";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import EnrolleeBill from "@/components/billing/EnrolleeBillComponent.vue";
import { normalizeBillingEncounter, normalizeBillingCluster } from "@/components/billing/billingData";
import SummaryBill from "@/components/billing/SummaryBillComponent.vue";
import SubmitSummary from "@/components/claim/SubmitSummaryClaimComponent.vue";
import {
    grossTotalSentFx,
    totalSentFx,
    totalApprovedFx,
    grossTotalApprovedFx,
    checkPaidFx,
    paymentStatusFx,
} from "@/composables/calFunction/cal";
import { downloadExcelFx } from "@/composables/reportFunction/downloader";
import { getFullMonthName } from "@/composables/fxLibrary/months";
import Modal from "@/components/alerts/ModalComponent.vue";
import { HMO } from '@/laravel/config';
import M from "materialize-css";

export default {
    name: "claimsAdd",
    props: ["clusterId", "active"],
    emits: ["menu", "active", "cancel"],
    components: { SubHeading, LoadingDiv, EnrolleeBill, SummaryBill, SubmitSummary, Modal },
    setup(props, context) {
        const lock = ref(true);
        const isManual = ref(false); // toggle manual claims
        const adder = ref(true);
        const serverTime = ref(null);
        const isReady = ref(false);
        const isLoading = ref(false);
        const isSubmitting = ref(false);
        const cluster = ref(null);
        const encounter = ref(null);
        const next = ref(false);
        const error = ref(null);
        const loadError = ref(null);
        const success = ref(null);
        const notifyTitle = ref(null);
        const notifyMessage = ref(null);
        const alertTitle = ref("Confirm");
        const alertMessage = ref("Are you sure you want to submit? Please confirm that all the details provided are accurate. Once submitted, changes cannot be made unless approved by your HMO.");
        const home = ref(null);
        const currTab = ref(null);
        const tabs = ref([]);
        const tabsState = ref([]);
        const currState = ref(null);

        // vue router
        const router = useRouter();

        // store
        const store = useStore();

        // config
        const providerId = store.state?.user?.account?.id;
        const billingDraftKey = "provider-billing-draft";
        const isManualScheme = (scheme) => {
            return scheme?.is_manual === true || scheme?.is_manual === 1 || scheme?.is_manual === "1";
        };
        const hasManualBillingSchemes = computed(() => {
            return (store.state?.user?.schemes || []).some(isManualScheme);
        });
        const canAddManualEncounter = computed(() => {
            return cluster.value?.status === "q" && isManualScheme(cluster.value?.scheme);
        });
        const syncEncounterInCluster = (value) => {
            if (!cluster.value || !value?.id) {
                return null;
            }

            const updatedEncounter = normalizeBillingEncounter(value);
            const currentEncounters = cluster.value.encounters || [];
            const exists = currentEncounters.some(
                item => Number(item.id) === Number(updatedEncounter.id),
            );

            if (exists) {
                const encounterIndex = currentEncounters.findIndex(
                    item => Number(item.id) === Number(updatedEncounter.id),
                );
                currentEncounters[encounterIndex] = updatedEncounter;
            } else {
                currentEncounters.push(updatedEncounter);
            }

            if (encounter.value && Number(encounter.value.id) === Number(updatedEncounter.id)) {
                encounter.value = updatedEncounter;
            }

            return updatedEncounter;
        };
        const isValidBillingDraft = (draft) => {
            return draft
                && draft._draft === true
                && cluster.value
                && cluster.value.status === "q"
                && Number(draft.cluster_id) === Number(cluster.value.id)
                && Number(draft.provider_id) === Number(cluster.value.provider_id)
                && Number(draft.scheme_id) === Number(cluster.value.scheme_id)
                && !!draft.diagnosis;
        };
        const billingDraft = computed(() => {
            const draft = getCache(billingDraftKey);

            if (!draft || !cluster.value) {
                return null;
            }

            if (!isValidBillingDraft(draft)) {
                return null;
            }

            return draft;
        });
        const isReviewTab = (tab) => {
            return tab?.title?.toLowerCase().includes("review");
        };
        const isReviewTabDisabled = (tab) => {
            return isReviewTab(tab) && !next.value;
        };

        // start
        onMounted(() => {
            // page name
            document.title = "View Claims";
        });

        // menu
        onMounted(() => {
            // load tab
            tabs.value.push({ id: 1, name: "Billing", title: "Home", icon: "arrow_back", url: "billing", hash: null, });
            tabs.value.push({ id: 2, name: "Billing", title: "Review", icon: null, url: null, hash: null });

            if (hasManualBillingSchemes.value) {
                tabs.value.push({ id: 3, name: "Billing", title: "Start", icon: "add", url: "billing", hash: "#batch-start" });
            }

            // set default
            currTab.value = tabs.value.find(x => x.title.includes("Review"));
            // set home
            home.value = tabs.value.find(x => x.title.includes("Review"));
        });

        let loadSequence = 0;
        const loadCluster = async () => {
            const sequence = ++loadSequence;
            error.value = null;
            loadError.value = null;
            isReady.value = false;
            isLoading.value = true;
            try {
                const { res, err } = await getItemsOfItemsOfItems("cluster/provider", providerId, props.clusterId);
                if (sequence !== loadSequence) return;
                if (!res.value) throw err.value || new Error("The billing batch could not be loaded.");
                const clusterData = normalizeBillingCluster(res.value.data);
                const monthYear = clusterData.month_year.split("_");
                clusterData.month = { search: Number(monthYear[0]), name: getFullMonthName(monthYear[0] - 1) };
                clusterData.year = { search: Number(monthYear[1]), name: monthYear[1] };
                cluster.value = clusterData;

                const draft = getCache(billingDraftKey);
                if (draft && !isValidBillingDraft(draft)) {
                    removeCache(billingDraftKey);
                }
            } catch (cause) {
                if (sequence !== loadSequence) return;
                loadError.value = cause?.message || "The billing batch could not be loaded. Please retry.";
            } finally {
                if (sequence === loadSequence) {
                    isReady.value = true;
                    isLoading.value = false;
                }
            }
        };

        watch(() => props.clusterId, () => {
            cluster.value = null;
            encounter.value = null;
            next.value = false;
            currState.value = tabsState.value[0] || null;
            success.value = null;
            isReady.value = false;
            loadCluster();
        }, { immediate: true });

        watch(
            () => store.state.realtimeAuthEvent?.event_id,
            (eventId) => {
                const event = store.state.realtimeAuthEvent;
                const matchesCluster = cluster.value?.encounters?.some(item => Number(item.id) === Number(event?.encounter_id));

                if (!eventId || !matchesCluster || encounter.value || billingDraft.value) {
                    return;
                }

                isLoading.value = true;
                loadCluster();
                store.commit("dismissRealtimeAuthNotice", eventId);
            }
        );


        // handle cancel
        const resetBillingScroll = (behavior = "auto") => {
            nextTick(() => {
                window.requestAnimationFrame(() => {
                    window.requestAnimationFrame(() => {
                        window.scrollTo({
                            top: 0,
                            behavior,
                        });
                    });
                });
            });
        };

        const handleCancel = () => {
            // clear temp save
            router.push({ name: "billing" }).then(() => {
                resetBillingScroll();
            });
        }

        // menu
        onMounted(() => {
            (async () => {
                const { res } = await getCachedServerDate(getItems);

                if (res.value) {
                    // current time
                    serverTime.value = res.value.data;
                }

            })();
        });

        // watch serverTime.value
        watchEffect(() => {
            if (serverTime.value) {
                // if (store.state.cluster) {
                if (Number(serverTime.value?.current_month) > Number(cluster.value?.month_year?.split("_")[0]) || Number(serverTime.value?.current_year) > Number(cluster.value?.month_year?.split("_")[1])) {
                    // open lock
                    lock.value = false;
                }
                // }
            }
        })

        // start
        onMounted(() => {
            // load tab
            tabsState.value.push({ id: 1, title: "Summary (All)" });
            tabsState.value.push({ id: 2, title: "Review" });
            // set default
            currState.value = tabsState.value[0];
            // send menu to parent
            context.emit("menu", tabsState.value);
        });

        // change state
        const handleState = (val) => {

            // clear all
            handleClear();

            // set
            if (val) {
                currState.value = val;
                router.push({ hash: "#top" });
            }

        }

        // close notification
        const handleOk = () => {
            // clear notification
            notifyTitle.value = null;
            notifyMessage.value = null;
            // Restore scrollbar (insurance)
            resetScrollBar();
        }

        // more
        onUpdated(() => {
            var elems = document.querySelectorAll(".dropdown-trigger");
            M.Dropdown.init(elems, {});
        });

        // alert
        onMounted(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            M.Modal.init(elems, {});
        });

        // alert
        onUpdated(() => {
            // modal
            const elems = document.querySelectorAll(".modal");
            M.Modal.init(elems, {});
        });

        //from functions
        const capWords = (val) => {
            return capWordsFx(val);
        };

        // ageSex
        const showAgeSex = (dob, sex) => {
            const { fx } = ageSex(dob, sex);
            return fx.value;
        };

        const billingSentTotal = computed(() => {
            return grossTotalSentFx(encounters.value);
        });

        const clusterPeriod = computed(() => {
            if (!cluster.value?.month?.name || !cluster.value?.year?.name) {
                return "Claims period";
            }

            return `${cluster.value.month.name} ${cluster.value.year.name}`;
        });

        const clusterStatusLabel = computed(() => {
            if (cluster.value?.status === "q") {
                return "Unsubmitted";
            }

            if (cluster.value?.status === "p") {
                return "Submitted";
            }

            if (cluster.value?.status === "v" || cluster.value?.status === "r") {
                return "Completed";
            }

            return "In Review";
        });

        const clusterStatusClass = computed(() => {
            if (cluster.value?.status === "q") {
                return "is-unvetted";
            }

            if (cluster.value?.status === "p") {
                return "is-submitted";
            }

            return "is-vetted";
        });

        const clusterPaymentStatus = computed(() => {
            if (!cluster.value) {
                return "Payment status";
            }

            if (cluster.value.status === "r" || cluster.value.status === "v") {
                return checkPaidFx(cluster.value) ? "Paid" : "Pending";
            }

            return paymentStatusFx(cluster.value);
        });

        const canDownloadPaymentAdvice = computed(() => {
            return cluster.value?.status !== "q" && !billingDraft.value && encounters.value.length > 0;
        });

        // scrollbar
        const resetScrollBar = () => {
            // Restore scrollbar (insurance)
            document.body.style.overflow = 'auto';
        }

        // clear all
        const handleClear = () => {
            error.value = null;
            success.value = null;
        }

        // handle curr status
        const handleActive = (tab) => {
            currTab.value = tab;
            // refer
            if (tab.hash) {
                router.push({ name: tab.url, hash: tab.hash });
            } else {
                router.push({ name: tab.url });
            }
        };

        // handle curr status
        const handleActiveState = (tab) => {
            if (isReviewTabDisabled(tab)) {
                return;
            }

            // handle tab
            if (tab) {
                currState.value = tab;
                // send back
                // to parent menu
                context.emit("active", tab);
            }
            // top
            if (currState.value?.title.toLowerCase().includes("summary")) {
                // open summary
                handleReview("view");
            } else if (currState.value?.title.toLowerCase().includes("review")) {
                // route display
                router.push({ hash: "#displays" });
            }
        };

        // monitor active
        watch(() => props.active, (newVal) => {
            if (newVal) {
                handleActiveState(newVal);
            }
        });

        // handle next
        const handleNext = async (val) => {

            // clear all 
            // notifications
            handleClear();

            // start
            if (cluster.value && val?.encounter) {

                if (val.encounter?._draft) {
                    handleDraftClear();
                    return;
                }

                if (val.submit) {
                    handleDraftClear();
                }

                syncEncounterInCluster(val.encounter);
                cluster.value.encounters = cluster.value.encounters.filter(x => x.status !== "d");
                // save payload
                // store.commit("loadCluster", cluster.value);

            }

            // if submit
            if (val.submit) {
                // close encounter
                encounter.value = null;
                // close enrolleeClaim
                next.value = false;
                // set default
                currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("summary"));
                // scroll up
                router.push({ hash: "#displays" });
            }

        };

        // handle reload
        const handleReload = (val) => {
            if (val.encounter?._draft) {
                if (!isValidBillingDraft(val.encounter)) {
                    handleDraftClear();
                    return;
                }
            }

            encounter.value = normalizeBillingEncounter(val.encounter);
            // editId.value = val.encounter.editId;
            next.value = true;
            // set default
            currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("review"));
            // to parent menu
            context.emit("active", currState.value);
            // scroll up
            router.push({ hash: "#top" });
        };

        const handleEncounterUpdated = (updatedEncounter) => {
            syncEncounterInCluster(updatedEncounter);
        };

        const handleEncounterBack = async (val) => {
            if (val?.encounter?.id && val.encounter.encounter_date_set && !val.encounter._draft) {
                syncEncounterInCluster(val.encounter);
            }

            await handleReview("view");
        };

        const handleEncounterRemoved = (val) => {
            if (!cluster.value || !val?.encounterId) {
                return;
            }

            cluster.value.encounters = (cluster.value.encounters || []).filter(
                item => Number(item.id) !== Number(val.encounterId),
            );
            handleDraftClear();
            encounter.value = null;
            next.value = false;
            currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("summary"));
            context.emit("active", currState.value);
            router.push({ hash: "#displays" });
        };

        // handle add enrollee
        const handleAddEnrollee = () => {
            if (!canAddManualEncounter.value || isSubmitting.value) {
                return;
            }

            const draft = getCache(billingDraftKey);

            if (draft && Number(draft.cluster_id) !== Number(cluster.value?.id)) {
                removeCache(billingDraftKey);
                encounter.value = null;
            } else if (isValidBillingDraft(draft)) {
                encounter.value = draft;
            } else {
                removeCache(billingDraftKey);
                encounter.value = null;
            }

            next.value = true;
            currState.value = tabsState.value?.find(x => x.title.toLowerCase().includes("review"));
            context.emit("active", currState.value);
            router.push({ hash: "#displays" });
        };

        // handle draft
        const handleDraft = (draft) => {
            if (!draft || !cluster.value || cluster.value.status !== "q" || !draft.diagnosis) {
                return;
            }

            const normalizedDraft = {
                ...draft,
                id: draft.id || `draft-${cluster.value.id}`,
                _draft: true,
                cluster_id: cluster.value.id,
                encounter_cluster_id: cluster.value.id,
                provider_id: cluster.value.provider_id,
                scheme_id: cluster.value.scheme_id,
                scheme: cluster.value.scheme,
                status: "q",
                updated_at: new Date().toISOString(),
            };

            addCache(billingDraftKey, normalizedDraft);
        };

        // clear draft
        const handleDraftClear = () => {
            removeCache(billingDraftKey);
        };

        // handle review
        const handleReview = async (val) => {
            if (val == "view") {
                next.value = false;
                // reset default
                currState.value = tabsState.value[0];
                // to parent menu
                context.emit("active", currState.value);
                // Wait for the summary table to replace the encounter view before scrolling.
                await nextTick();
                await router.push({ hash: "#billing-summary-list" });
            } else if (val == "add") {
                handleAddEnrollee();
            }
        };

        // download
        const handleDownload = () => {
            if (!canDownloadPaymentAdvice.value) {
                return;
            }

            const data = [];

            encounters.value.forEach((x, y) => {
                x.claims.forEach((z, j) => {
                    const row = {
                        No: j === 0 ? y + 1 : "",
                        Name: j === 0 ? x.name : "",
                        ID: j === 0 ? x.enrollee_number : "",
                        Encounter: j === 0 ? x.encounter_date : "",
                        End: j === 0 ? x.encounter_date_end : "",
                        Diagnosis: j === 0 ? x.diagnosis : "",
                        Item: z.item,
                        sent_qty: z.sent_qty,
                        appr_qty: x.status == "d" || z.status == "d" ? 0 : z.approved_qty,
                        Sent: z.sent_price,
                        Approved: x.status == "d" || z.status == "d" ? 0 : z.approved_price,
                        Comment: z.comment,
                    };

                    data.push(row);
                });

                data.push({
                    No: "",
                    Name: "",
                    ID: "",
                    Encounter: "",
                    End: "",
                    Diagnosis: "",
                    Item: "",
                    sent_qty: "",
                    appr_qty: "",
                    Sent: totalSentFx(x),
                    Approved: totalApprovedFx(x),
                    Comment: "",
                });

                data.push({});
            });

            data.push({});
            data.push({
                No: "",
                Name: "",
                ID: "",
                Encounter: "",
                End: "",
                Diagnosis: "",
                Item: "",
                sent_qty: "",
                appr_qty: "Final",
                Sent: grossTotalSentFx(encounters.value),
                Approved: grossTotalApprovedFx(encounters.value),
                Comment: "",
            });

            return downloadExcelFx(data, `${cluster.value.provider?.name || "Provider"}_${cluster.value.scheme?.name || "Scheme"}_${clusterPeriod.value} Claims`);
        }

        // confirmation
        const handleConfirm = (val) => {
            // call submit if confirmed
            if (val) {
                // p = submitted
                handleSubmit("p");
            } else {
                // Restore scrollbar (insurance)
                resetScrollBar();
            }
        }

        // handle review
        const handleSubmit = async (clusterStatusVal) => {

            // check first
            if (!encounters.value.find(x => x.status === 'q') && !billingDraft.value) {

                // clear all 
                // notifications
                handleClear();

                // start
                isSubmitting.value = true;
                // clear error
                error.value = null;

                // go
                const { res } = await putItem("cluster", cluster.value.id, {
                    status: clusterStatusVal,
                });


                if (res.value) {
                    if (res.value.data.status !== "q") {
                        handleDraftClear();
                    }

                    // next action
                    if (res.value.data.status === "q") {

                        // nothing, just back home
                        handleState("c"); // c=current, u=user, h=hmo, n=null

                        // clear
                        cluster.value = null;


                    } else {

                        if (res.value.data.status === "p") {
                            // load success cluster
                            // res.value.data.month = cluster.value.month.name;
                            // res.value.data.year = cluster.value.year.name;
                            // res.value.data.scheme = cluster.value.scheme;

                            //load cluster
                            cluster.value.status = res.value.data.status;

                            // filter
                            cluster.value.encounters.filter(x => x.status !== "d");

                            // save payload
                            //   store.commit("loadCluster", cluster.value);

                            M.toast({
                                html: "Final claims submitted successfully <i class='material-icons'>check_circle</i>",
                                displayLength: 5000,
                                inDuration: 300,
                                outDuration: 300,
                            });

                            // reset
                            handleState("c"); // c=current, u=user, h=hmo, n=null

                        } else {
                            // nothing, just back home
                            handleState("c"); // c=current, u=user, h=hmo, n=null
                        }

                    }

                } else {
                    error.value = "Sorry, Something went wrong!";
                }

                // Restore scrollbar (insurance)
                resetScrollBar();

                // end
                isSubmitting.value = false; // in case of incasecity!

            }

        };

        // output claims results
        const encounters = computed(() => {
            if (!cluster.value || !("encounters" in cluster.value)) {
                return [];
            } else {
                return cluster.value.encounters;
            }
        });

        const encountersWithDraft = computed(() => {
            if (!billingDraft.value) {
                return encounters.value;
            }

            return [...encounters.value, billingDraft.value];
        });

        return {
            loadCluster,
            lock,
            isManual,
            adder,
            handleCancel,
            handleActive,
            handleActiveState,
            handleDownload,
            home,
            currTab,
            tabs,
            tabsState,
            currState,
            capWords,
            showAgeSex,
            billingSentTotal,
            clusterPeriod,
            clusterStatusLabel,
            clusterStatusClass,
            clusterPaymentStatus,
            canDownloadPaymentAdvice,
            handleOk,
            handleClear,
            handleState,
            handleConfirm,
            handleReview,
            handleAddEnrollee,
            handleDraft,
            handleDraftClear,
            handleNext,
            handleReload,
            handleEncounterUpdated,
            handleEncounterBack,
            handleEncounterRemoved,
            handleSubmit,
            notifyTitle,
            notifyMessage,
            alertTitle,
            alertMessage,
            success,
            error,
            loadError,
            isReady,
            isLoading,
            isSubmitting,
            next,
            cluster,
            encounter,
            encounters,
            encountersWithDraft,
            canAddManualEncounter,
            isReviewTabDisabled,
            HMO: HMO,
        };
    },
};
</script>

<style scoped>
.progress {
    margin: 0;
    border-radius: 0;
}

.clickable {
    cursor: pointer;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.clickable:hover {
    opacity: 0.8;
}

.pointable {
    cursor: default;
    opacity: 1;
    transition: opacity 0.3s ease;
}

.pointable:hover {
    opacity: 0.8;
}

.spacer {
    padding: 2px;
}

.pointer {
    cursor: default;
}

.claim-view-container {
    margin-top: -18px;
    padding-bottom: 12px;
    position: relative;
    z-index: 3;
}

.care-billing-view-surface.is-workbench > .claim-view-container {
    margin-top: -18px;
}

:global(.care-billing-view-breadcrumb) {
    background: #ffffff !important;
    background-color: #ffffff !important;
    position: relative;
    z-index: 1;
}

:global(.care-billing-view-breadcrumb::after) {
    background: #c4d3d9;
    bottom: 0;
    content: "";
    height: 1px;
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    z-index: 1;
}

:global(html:has(.care-billing-view-container)),
:global(body:has(.care-billing-view-container)),
:global(.app-shell:has(.care-billing-view-container)),
:global(.app-shell:has(.care-billing-view-container) main),
:global(.sba-collection-page-surface:has(.care-billing-view-container)) {
    background: var(--care-gutter-bg) !important;
    background-color: var(--care-gutter-bg) !important;
}

:global(.sba-collection-page-surface:has(.care-billing-view-container)) {
    min-height: 0;
    padding-bottom: 12px;
}

:global(.app-shell:has(.care-billing-view-container)) {
    min-height: 0;
}

:global(.app-shell:has(.care-billing-view-container) main) {
    padding-bottom: 0;
}

.claim-review-workbench {
    color: #263238;
    padding-bottom: 12px;
    padding-top: 0;
    transform: none !important;
    width: 100%;
}

.claim-super-card,
.claim-dossier-card,
.claim-dossier-metrics,
.claim-mode-strip,
.claim-secondary-body-frame {
    animation: sbaSlideIn var(--sba-slide-duration, 260ms) ease-out both;
}

.claim-secondary-header {
    background: #ffffff;
    border: 1px solid #c4d3d9;
    border-radius: 6px 6px 0 0;
    box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
    margin-bottom: 0;
    overflow: visible;
    position: relative;
    z-index: 3;
}

.claim-secondary-header::before {
    border: 1px solid #c4d3d9;
    border-bottom: 0;
    border-radius: 7px 7px 0 0;
    content: "";
    height: 12px;
    left: -1px;
    pointer-events: none;
    position: absolute;
    right: -1px;
    top: -1px;
}

.claim-super-card,
.claim-dossier-card,
.claim-dossier-metrics,
.claim-mode-strip {
    background: #ffffff;
    border: 0;
    border-radius: 0;
    box-shadow: none;
}

.claim-super-card {
    align-items: center;
    background: #ffffff;
    border-bottom: 1px solid #d8e4e8;
    border-radius: 6px 6px 0 0;
    box-shadow: none;
    display: flex;
    gap: 10px;
    min-height: 46px;
    padding: 12px 18px 10px;
    position: relative;
    width: 100%;
    z-index: 4;
}

.secondary-page-back {
    align-items: center;
    background: #00897b;
    border: 1px solid #00796b;
    border-radius: 0;
    color: #ffffff;
    cursor: pointer;
    display: inline-flex;
    flex: 0 0 auto;
    height: 24px;
    justify-content: center;
    margin: 0;
    padding: 0;
    width: 24px;
}

.secondary-page-back i {
    color: #ffffff;
    font-size: 16px;
    line-height: 16px;
}

.claim-super-copy {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.15;
}

.secondary-parent-link {
    background: transparent;
    border: none;
    border-radius: 4px;
    color: #4e342e;
    cursor: pointer;
    font: inherit;
    font-size: 0.78rem;
    font-weight: 800;
    margin: 0;
    padding: 0;
    text-align: left;
    text-transform: uppercase;
}

.claim-super-copy small {
    color: #6d4c41;
    font-size: 0.72rem;
    font-weight: 700;
}

.claim-dossier-card {
    align-items: flex-end;
    background: #ffffff;
    border-radius: 0;
    box-shadow: none;
    display: flex;
    gap: 22px;
    justify-content: space-between;
    padding: 26px 34px;
    position: relative;
}

.claim-dossier-title label {
    display: block;
    font-size: 0.82rem;
    font-weight: 600;
    margin-bottom: 8px;
}

.claim-dossier-title h5 {
    color: #263238;
    font-weight: 700;
    margin: 4px 0 0;
    overflow-wrap: anywhere;
}

.claim-dossier-title p {
    color: #607d8b;
    line-height: 1.55;
    margin: 0;
    max-width: 760px;
}

.claim-dossier-context {
    align-items: flex-end;
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
    max-width: 430px;
}

.context-pill {
    background: #fafafa;
    border: 1px solid #e1e8eb;
    border-radius: 999px;
    color: #455a64;
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 700;
    line-height: 1.2;
    padding: 8px 11px;
}

.context-pill.is-unvetted {
    background: #fff4d6;
    border-color: #f1c75b;
    color: #795000;
}

.context-pill.is-submitted {
    background: #d7f5ee;
    border-color: #26a69a;
    color: #00796b;
}

.context-pill.is-vetted {
    background: #e0f2f1;
    border-color: #80cbc4;
    color: #00695c;
}

.context-pill.is-payment {
    background: #eceff1;
    color: #263238;
}

.claim-dossier-metrics {
    background: linear-gradient(90deg, #f7fcfb 0%, #fffaf0 100%);
    border-top: 1px solid #c4d3d9;
    border-radius: 0;
    box-shadow: none;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    margin-bottom: 0;
}

.metric-cell {
    background: #ffffff;
    border-left: 1px solid #e1e8eb;
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-height: 76px;
    padding: 17px 22px;
}

.metric-cell:first-child {
    border-left: 0;
}

.metric-cell:nth-child(2n) {
    background: #f8fbfb;
}

.metric-cell span {
    color: #607d8b;
    font-size: 0.74rem;
    font-weight: 700;
    text-transform: uppercase;
}

.metric-cell strong {
    color: #263238;
    font-size: 1.02rem;
    font-weight: 800;
    line-height: 1.35;
}

.metric-cell:first-child strong {
    color: #00695c;
}

.metric-cell:nth-child(2) strong {
    color: #795000;
}

.metric-action-cell {
    align-items: stretch;
    justify-content: center;
}

.download-action {
    align-items: center;
    background: linear-gradient(90deg, #f7fcfb 0%, #fffaf0 100%);
    border: 1px solid #c4d3d9;
    border-radius: 0;
    color: #263238;
    cursor: pointer;
    display: inline-flex;
    font-size: 0.82rem;
    font-weight: 800;
    gap: 8px;
    justify-content: center;
    min-height: 42px;
    padding: 0 14px;
    transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.download-action:hover:not(:disabled):not(.is-disabled) {
    background: #e0f2f1;
    border-color: #26a69a;
    color: #00695c;
}

.download-action.is-submitted-download {
    background: #d9f8ef;
    border-color: #26a69a;
    color: #00695c;
    box-shadow: inset 0 0 0 1px rgba(0, 137, 123, 0.08);
}

.download-action i {
    color: #00897b;
    font-size: 19px;
}

.download-action.is-submitted-download i {
    color: #00897b;
}

.download-action.is-disabled,
.download-action:disabled {
    background: #fff8e1;
    border-color: #f6d98d;
    color: #8a6d1f;
    cursor: not-allowed;
}

.download-action.is-disabled i,
.download-action:disabled i {
    color: #f9a825;
}

.claim-mode-strip {
    align-items: center;
    background: linear-gradient(90deg, #ffffff 0%, #f7fcfb 50%, #ffffff 100%);
    border-top: 1px solid #c4d3d9;
    border-radius: 0;
    display: flex;
    gap: 14px;
    justify-content: center;
    min-height: 68px;
    padding: 8px 16px;
    position: relative;
}

.claim-mode-close {
    align-items: center;
    background: #eef3f5;
    border: 1px solid #d6e1e6;
    border-radius: 4px;
    color: #ef6c00;
    cursor: pointer;
    display: inline-flex;
    height: 32px;
    justify-content: center;
    left: 16px;
    position: absolute;
    transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
    width: 34px;
}

.claim-mode-close:hover {
    background: #fff3e0;
    border-color: #ffcc80;
    color: #e65100;
}

.claim-mode-close i {
    font-size: 19px;
}

.claim-mode-actions {
    background: #f8fbfb;
    border: 1px solid #d8e4e8;
    border-radius: 4px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    padding: 3px;
}

.claim-mode-option {
    background: transparent;
    border: 0;
    border-bottom: 3px solid transparent;
    color: #607d8b;
    cursor: pointer;
    font-size: 0.84rem;
    font-weight: 800;
    min-height: 40px;
    padding: 0 14px;
    text-transform: uppercase;
    transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}

.claim-mode-option:hover:not(:disabled):not(.is-disabled) {
    background: #edf7f5;
    color: #00695c;
}

.claim-mode-option.is-active {
    background: #ffffff;
    border-bottom-color: #00897b;
    color: #00695c;
}

.claim-mode-option.is-disabled,
.claim-mode-option:disabled {
    color: #9cafb8;
    cursor: default;
    opacity: 0.55;
}

.claim-mode-option.is-disabled:hover,
.claim-mode-option:disabled:hover {
    border-bottom-color: transparent;
}

.claim-secondary-body-frame {
    background: #ffffff;
    border: 1px solid #c4d3d9;
    border-radius: 0;
    box-shadow: none;
    box-sizing: border-box;
    margin-top: 14px;
    overflow: visible;
    padding: 16px;
    position: relative;
    z-index: 10;
}

.claim-secondary-body-frame .progress {
    height: 4px;
    margin: -16px -16px 16px;
}

.claim-secondary-body-frame :deep(.section) {
    padding-bottom: 0;
    padding-top: 0;
}

.claim-secondary-body-frame :deep(.card),
.claim-secondary-body-frame :deep(.card-panel) {
    border-radius: 0;
    box-shadow: none;
}

.claim-secondary-body-frame :deep(.grey.lighten-4),
.claim-secondary-body-frame :deep(.grey.lighten-5) {
    background-color: #ffffff !important;
}

.claim-secondary-body-frame :deep(.collection) {
    border: 1px solid #d8e4e8;
    border-radius: 0;
    overflow: hidden;
}

.claim-secondary-body-frame :deep(.collection-item) {
    border-bottom-color: #e6eef1;
}

.care-submit-row {
    align-items: center;
    background: #ffffff;
    border: 1px solid #d8e4e8;
    display: flex;
    gap: 16px;
    justify-content: flex-end;
    margin: 16px 0 0;
    padding: 16px;
}

.care-add-enrollee-button {
    background: #243746;
    border-radius: 0;
    box-shadow: none;
    font-weight: 800;
    margin-right: auto;
    min-width: 220px;
}

.care-add-enrollee-button:hover,
.care-add-enrollee-button:focus {
    background: #172733;
    box-shadow: none;
}

.care-submit-button {
    background: #00897b;
    border-radius: 0;
    box-shadow: none;
    font-weight: 800;
    min-width: 260px;
}

.claim-review-workbench > .claim-secondary-header,
.claim-review-workbench > .claim-secondary-body-frame {
    box-shadow:
        -8px 0 16px -15px rgba(38, 50, 56, 0.45),
        8px 0 16px -15px rgba(38, 50, 56, 0.45),
        0 10px 18px -20px rgba(38, 50, 56, 0.35) !important;
}

:global(.care-billing-confirm-modal) {
    left: 50% !important;
    max-width: 720px;
    position: fixed !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    width: min(720px, calc(100vw - 32px));
    z-index: 10060 !important;
}

:global(.modal-overlay) {
    height: 100vh !important;
    left: 0 !important;
    position: fixed !important;
    top: 0 !important;
    width: 100vw !important;
    z-index: 10050 !important;
}

@media only screen and (max-width: 600px) {
    .claim-view-container {
        margin-top: -12px;
        padding-left: 12px;
        padding-right: 12px;
    }

    .claim-dossier-card,
    .claim-dossier-metrics,
    .claim-mode-strip,
    .care-submit-row {
        display: flex;
        flex-direction: column;
    }

    .care-add-enrollee-button,
    .care-submit-button {
        width: 100%;
    }

    .claim-dossier-card {
        align-items: flex-start;
        padding: 22px;
    }

    .claim-dossier-title h5 {
        font-size: 1.45rem;
    }

    .claim-dossier-context {
        justify-content: flex-start;
        max-width: none;
    }

    .claim-dossier-metrics {
        display: grid;
        grid-template-columns: 1fr;
    }

    .metric-cell {
        border-left: 0;
        border-top: 1px solid #e1e8eb;
    }

    .metric-cell:first-child {
        border-top: 0;
    }

    .claim-mode-close {
        left: auto;
        position: static;
    }

    .claim-mode-actions,
    .claim-mode-option,
    .download-action {
        width: 100%;
    }

    .claim-secondary-body-frame {
        padding: 12px;
    }

    .claim-secondary-body-frame :deep(.card-content),
    .claim-secondary-body-frame :deep(.card-panel) {
        padding: 16px;
    }

    .care-submit-row {
        padding: 0;
    }

    .care-submit-button {
        width: 100%;
    }
}

@media (prefers-reduced-motion: reduce) {
    .claim-super-card,
    .claim-dossier-card,
    .claim-dossier-metrics,
    .claim-mode-strip,
    .claim-secondary-body-frame {
        animation: none;
    }
}
</style>
